import { Classes } from '@blueprintjs/core';
import * as React from 'react';

import { copy } from 'src/ui/templates/copy';
import googleButton from 'src/ui/templates/images/google-icon.svg';
import { doGoogleRedirect } from 'src/ui/utils/window';

/**
 * This uses just a plain button as we use an image to display the actual
 * button. We don't want this to be styled by blueprintjs.
 */
export const GoogleLink: React.VFC = () => {
  return (
    <button
      type="button"
      onClick={doGoogleRedirect}
      className={`${Classes.BUTTON} oauth`}
    >
      <img src={googleButton} alt={copy.google.label} />
      {copy.google.label}
    </button>
  );
};
